import { render } from "./Play.vue?vue&type=template&id=4c18a09f&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"

import "./Play.vue?vue&type=style&index=0&id=4c18a09f&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c18a09f"]])

export default __exports__